export function formatDuration(duration: number) {
  const hours = Math.floor(duration / (60 * 60));
  const minutes = Math.floor((duration % (60 * 60)) / 60);
  const seconds = duration - hours * 60 * 60 - minutes * 60;
  return [hours, minutes, seconds]
    .map((elem) => String(elem).padStart(2, "0"))
    .join(":");
}
